import { render, staticRenderFns } from "./add_payment.vue?vue&type=template&id=a6f54e62"
import script from "./add_payment.vue?vue&type=script&lang=js"
export * from "./add_payment.vue?vue&type=script&lang=js"
import style0 from "./add_payment.vue?vue&type=style&index=0&id=a6f54e62&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports